import type { Filter } from '@/components/table-filters/constants';
import {
  defaultRelationFilter,
  defaultStringFilter,
} from '@/components/table-filters/constants';
import {
  ParkingSpotQueueConfig,
  RealEstateConfig,
  SegmentConfig,
} from '@pigello/pigello-matrix';

export const parkingSpotQueueFilters: Filter[] = [
  {
    ...defaultStringFilter,
    title: ParkingSpotQueueConfig.fields.name.verboseName,
    externalFieldName: ParkingSpotQueueConfig.fields.name.externalFieldName,
  },
  {
    ...defaultRelationFilter,
    title:
      ParkingSpotQueueConfig.fields.allowedSegmentForListing.verboseName,
    externalFieldName:
      ParkingSpotQueueConfig.fields.allowedSegmentForListing
        .externalFieldName,
    relationModelName: SegmentConfig.modelName,
  },
  {
    ...defaultRelationFilter,
    title:
      ParkingSpotQueueConfig.fields.requiredRealestatesForEnrollment
        .verboseName,
    externalFieldName:
      ParkingSpotQueueConfig.fields.requiredRealestatesForEnrollment
        .externalFieldName,
    relationModelName: RealEstateConfig.modelName,
  },
];
